module.exports = __webpack_public_path__ + "static/media/care_in_hospital_map_important.b6da817f.svg";